import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const GetQuestionTrends = 'GET_QUESTION_TRENDS';

export const useGetQuestionTrends = (
  fromDate: string,
  toDate: string,
  teamId: number,
  enabled: boolean = true,
) => {
  const { fetchQuestionTrends } = useServicesContext();

  return useQuery({
    queryKey: [GetQuestionTrends, fromDate, toDate, teamId],
    queryFn: () => fetchQuestionTrends(teamId!, fromDate, toDate),
    refetchInterval: 60000 * 5,
    enabled: enabled && Boolean(teamId),
  });
};